import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "@/lib/motion";
import { Star, Quote, ChevronLeft, ChevronRight, BadgeCheck } from "lucide-react";

export default function ReviewsCarousel({ reviews = [] }) {
    const [i, setI] = useState(0);
    const n = reviews.length;

    useEffect(() => {
        if (n < 2) return;
        const t = setInterval(() => setI((p) => (p + 1) % n), 6000);
        return () => clearInterval(t);
    }, [n]);

    if (!n) return null;
    const r = reviews[i];
    const go = (d) => setI((p) => (p + d + n) % n);

    return (
        <div className="relative mx-auto max-w-3xl">
            <div className="relative rounded-3xl border border-caramel/10 bg-white p-8 shadow-warm sm:p-12">
                <Quote size={56} className="absolute -top-5 left-8 text-banana" fill="#FADB5F" />
                <AnimatePresence mode="wait">
                    <motion.div
                        key={i}
                        initial={{ opacity: 0, y: 16 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -16 }}
                        transition={{ duration: 0.4 }}
                    >
                        <div className="flex gap-1 text-gold">
                            {Array.from({ length: 5 }).map((_, k) => (
                                <Star key={k} size={18} className={k < r.rating ? "fill-gold" : "opacity-30"} />
                            ))}
                        </div>
                        <p className="mt-5 font-serif text-xl leading-relaxed text-roast sm:text-2xl">“{r.text}”</p>
                        <div className="mt-7 flex items-center gap-3">
                            <div className="grid h-12 w-12 place-items-center rounded-full bg-caramel font-semibold text-cream-50">
                                {r.initials}
                            </div>
                            <div>
                                <p className="flex items-center gap-1.5 font-medium text-roast">
                                    {r.name}
                                    {r.verified && <BadgeCheck size={16} className="text-caramel" />}
                                </p>
                                <p className="text-sm text-mocha">Purchased · {r.flavor}</p>
                            </div>
                        </div>
                    </motion.div>
                </AnimatePresence>
            </div>

            <div className="mt-6 flex items-center justify-center gap-4">
                <button onClick={() => go(-1)} className="grid h-10 w-10 place-items-center rounded-full border border-caramel/20 text-roast transition-colors hover:bg-cream-200" aria-label="Previous"><ChevronLeft size={20} /></button>
                <div className="flex gap-2">
                    {reviews.map((_, k) => (
                        <button key={k} onClick={() => setI(k)} aria-label={`Go to ${k + 1}`} className={`h-2 rounded-full transition-all ${k === i ? "w-6 bg-caramel" : "w-2 bg-caramel/30"}`} />
                    ))}
                </div>
                <button onClick={() => go(1)} className="grid h-10 w-10 place-items-center rounded-full border border-caramel/20 text-roast transition-colors hover:bg-cream-200" aria-label="Next"><ChevronRight size={20} /></button>
            </div>
        </div>
    );
}
